import { Link } from "gatsby";

import {
  AspectImage,
  AspectRatio,
  Box,
  Heading,
  Stack,
  Text,
} from "@vinomofo/components";

import { BannerButton, BannerProps } from "../banner";

const alignmentFromContentPosition = {
  Left: "flex-start",
  Middle: "center",
  Right: "flex-end",
};

export const BannerInline = ({
  bannerTitle,
  bodyText,
  bodyTextColor,
  backgroundImage,
  backgroundColor,
  titleColor,
  contentPosition,
  cta,
  linkTo,
}: BannerProps): JSX.Element => {
  const ctaLink = linkTo?.slug || linkTo?.url;

  const wrapperAspectRation = (aspectRatio: number): Array<number> => {
    const mobileAspectRatio = aspectRatio > 1 ? 1 : aspectRatio || 1;
    const desktopAspectRation = aspectRatio || 2.5;
    return [mobileAspectRatio, desktopAspectRation];
  };

  return (
    <AspectRatio
      width="100%"
      position="relative"
      display="flex"
      ratio={wrapperAspectRation(backgroundImage?.fluid?.aspectRatio)}
      backgroundColor={backgroundColor}
      flexDirection={["column", "row"]}
      justifyContent={[
        "center",
        alignmentFromContentPosition[contentPosition] || "flex-start",
      ]}
    >
      {backgroundImage && (
        <Box
          width="100%"
          position={["static", "absolute"]}
          top={0}
          bottom={0}
          left={0}
          right={0}
        >
          <AspectImage
            ratio={backgroundImage.fluid.aspectRatio}
            src={backgroundImage.fluid.src}
          />
        </Box>
      )}

      <Box
        width={["auto", "50%"]}
        height="100%"
        position="relative"
        display="flex"
        alignItems="center"
        textAlign="center"
        justifyContent="center"
        padding={[2, 5]}
      >
        <Stack space={2}>
          <Heading variant="lg" color={titleColor}>
            {bannerTitle}
          </Heading>
          <Text color={bodyTextColor}>{bodyText}</Text>
          {cta && (
            <Link to={ctaLink}>
              <BannerButton
                variant="outline"
                borderColor={titleColor}
                color={titleColor}
                backgroundColor={backgroundColor}
              >
                {cta}
              </BannerButton>
            </Link>
          )}
        </Stack>
      </Box>
    </AspectRatio>
  );
};
